import { render } from "./SejarahBayaran.vue?vue&type=template&id=512d7bdd"
import script from "./SejarahBayaran.vue?vue&type=script&lang=js"
export * from "./SejarahBayaran.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__